/* PROTOCOL renewal personalisation
   Additive layer for the CHT renew flow. Reads optional query params written
   by the /renew/{firstname} redirects:
     fn    first name
     mk    up to two short marker labels, comma separated, lowercase letters
           and spaces only (e.g. "cholesterol,vitamin levels")
     age   u35 | 35-49 | 50+
     sex   male | female
     goal  comma separated matcher goals
     rd    renewal date, YYYY-MM-DD, drives the membership line in the
           order summary
     email carried through to the booking page, then scrubbed from the URL

   Load order matters. This file is loaded SYNCHRONOUSLY from
   protocol-flow-v6-boot.liquid, which sits after main, so it executes after
   the page's own inline script has registered its DOMContentLoaded handler
   but before that handler fires. That ordering is what lets us overwrite
   applyCtxCopy()'s generic copy without a flash:
     1. synchronously mask the heading and lede (visibility only, no reflow)
     2. on DOMContentLoaded, after applyCtxCopy has run, write our copy
     3. reveal
   A watchdog reveals unconditionally in case anything above throws.
   With no params present nothing is masked and nothing is changed, so
   public /pages/renew traffic is untouched. */
(function(){
  'use strict';

  var GREEN = '#2C5945';
  var GOLD  = '#FFD166';
  var IDS   = ['addon-heading','addon-lede'];

  function qp(n){
    try{ return new URLSearchParams(window.location.search).get(n) || ''; }
    catch(e){ return ''; }
  }
  function clean(s){ return String(s||'').replace(/[<>{}\\]/g,'').trim(); }
  function firstName(){
    var fn = clean(qp('fn')).slice(0,40);
    return /^[A-Za-z][A-Za-z'\- ]{0,39}$/.test(fn) ? fn : '';
  }
  /* only lowercase letters and single spaces survive, safe for innerHTML */
  function markers(){
    return clean(qp('mk')).toLowerCase().split(',')
      .map(function(s){ return s.trim().replace(/\s+/g,' '); })
      .filter(function(s){ return /^[a-z ]{2,24}$/.test(s); })
      .slice(0,2);
  }
  function hl(t){ return '<strong style="font-weight:500;color:'+GREEN+'">'+t+'</strong>'; }

  /* captured once at load: the query string is cleaned of `email` after boot,
     so anything needing it must read this, not the URL */
  var EMAIL = (function(){
    var e = qp('email').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e) ? e : '';
  })();

  /* Removes only `email` from the address bar once every consumer has read
     it. fn and mk stay so a reload still renders the personalised page.
     Runs after flow v6 and its siblings have booted. */
  function scrubUrl(){
    try{
      if(!window.history || !history.replaceState) return;
      var u = new URL(window.location.href);
      if(!u.searchParams.has('email')) return;
      u.searchParams.delete('email');
      history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
    }catch(e){}
  }

  var masked = false;
  /* Two masks are in play. The CSS one is set before main renders, by the
     inline script in protocol-flow-v6-fouc-boot.liquid, and is what actually
     prevents the generic copy painting. This inline one is a second belt for
     browsers that reach the script before the class applies. Both are lifted
     together once the personalised copy is written. */
  function mask(on){
    IDS.forEach(function(id){
      var el = document.getElementById(id);
      if(el) el.style.visibility = on ? 'hidden' : '';
    });
    if(!on){
      try{
        document.documentElement.className =
          document.documentElement.className.replace(/\bpv6-personalising\b/g,'').trim();
      }catch(e){}
    }
    masked = on;
  }

  function writeCopy(){
    var fn = firstName(), mk = markers();

    if(fn){
      var h = document.getElementById('addon-heading');
      if(h) h.innerHTML = hl(fn) + ', time for your year two panel';
    }

    var l = document.getElementById('addon-lede');
    if(l && qp('mk') !== null){
      var lead;
      if(mk.length === 2){
        lead = 'Last time, your ' + hl(mk[0]) + ' and ' + hl(mk[1]) +
               ' were worth watching. ' + hl('This panel measures them again.');
      } else if(mk.length === 1){
        lead = 'Last time, your ' + hl(mk[0]) +
               ' was worth watching. ' + hl('This panel measures it again.');
      } else {
        lead = 'Everything was in range last time. ' +
               hl('This panel is where that becomes a trend.');
      }
      l.innerHTML = lead +
        '<span style="display:block;margin-top:9px;font-size:13.5px;opacity:.75">' +
        'Want to go deeper? Add optional tests to the same blood draw, at member pricing.' +
        '</span>';
    }
  }

  /* Repeat add-ons the member already bought in year one. Keyed by a short
     code in the `rp` param. Genetics are deliberately absent: those results
     do not change, so a repeat would be wrong. Copy lives here, not in the
     URL, so wording changes need no redirect edits. */
  var RP = {
    spotmas: {
      what: 'a multi cancer blood test',
      /* 12 Aug 2026: Guardant was archived and SPOT-MAS reinstated as the
         cancer screen. This copy no longer names any product, states no
         price and makes no comparison between the two tests. That is
         deliberate on three counts: the price moved (they paid roughly
         S$1,548 each in Aug 2025, it is S$899 now), the catalogue below is
         the single source for what it costs today, and naming products
         invites a comparison we are not going to make in writing. The test
         is prescription only, so the card routes to a doctor either way. */
      line: 'You can add this year\'s below, and Dr Edith or Dr Bryan will go through it ' +
            'with you before your draw.',
      noRepeatVerb: true,
      cancerHead: true
    },
    dexa: {
      what: 'a DEXA scan',
      line: 'A second scan is where body composition becomes a trend rather than a single reading.'
    },
    insulin: {
      what: 'a fasting insulin test',
      line: 'Repeating it on the same draw shows how your metabolic picture has moved.'
    },
    cortisol: {
      what: 'a morning cortisol test',
      line: 'Repeating it on the same draw shows whether the pattern has shifted.'
    },
    gut: {
      what: 'a gut health test',
      line: 'A second test is the only way to see whether the changes you made worked.'
    }
  };

  function repeatCard(){
    var raw = clean(qp('rp')).toLowerCase();
    if(!raw || document.getElementById('pv6-repeat')) return;
    var keys = raw.split(',').map(function(s){ return s.trim(); })
                  .filter(function(s){ return RP.hasOwnProperty(s); }).slice(0,2);
    if(!keys.length) return;
    var whats = keys.map(function(k){ return RP[k].what; });
    var what  = whats.length === 2 ? whats[0] + ' and ' + whats[1] : whats[0];
    var body  = RP[keys[0]].line;
    var quiet = !!RP[keys[0]].noRepeatVerb;
    var cancerHead = !!RP[keys[0]].cancerHead;
    var verb  = whats.length === 2 ? 'Repeating both on the same visit' : 'Repeating it on the same visit';

    var host = document.getElementById('matchbar');
    if(!host || !host.parentNode) return;
    var card = document.createElement('div');
    card.id = 'pv6-repeat';
    card.style.cssText = 'display:flex;gap:11px;align-items:flex-start;'+
      'background:rgba(44,89,69,.085);border:1px solid rgba(44,89,69,.24);'+
      'border-radius:14px;padding:14px 16px;margin:18px 0 0;';
    card.innerHTML =
      '<span style="flex:0 0 auto;width:19px;height:19px;border-radius:50%;background:'+GREEN+';'+
        'color:#fff;font-size:12px;line-height:19px;text-align:center;margin-top:1px;">&#8635;</span>'+
      '<span style="font-size:13px;line-height:1.55;color:var(--taupe,#5d564e)">'+
        '<b style="display:block;font-weight:500;color:'+GREEN+';margin-bottom:2px;">'+(cancerHead?'Continue your cancer screening':'Continue tracking')+'</b>'+
        (quiet
          ? 'You did ' + hl(what) + ' last year, and it is designed as an annual series. '
          : 'You did ' + hl(what) + ' last year. ' + verb + ' is how you see what changed. ') +
        body +
      '</span>';
    host.parentNode.insertBefore(card, host);
  }

  /* Renewal date line in the order summary.

     Sits inside the Core Health Test block, directly under its description,
     so it answers the question the "Included" pill raises: why does this
     line cost nothing. Deliberately NOT under the totals row, where it
     would read as a note about the add-on payment — that money is a
     separate Shopify charge, the membership is Stripe.

     Self-correcting: before the date it names it, on or after it states the
     membership is active. A static redirect cannot know whether the charge
     has landed, so the page works it out. Renders nothing at all if rd is
     missing or malformed. */
  var MONTHS = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];

  function renewalLine(){
    var rd = clean(qp('rd'));
    if(!/^\d{4}-\d{2}-\d{2}$/.test(rd)) return;
    if(document.getElementById('pv6-renews')) return;

    var parts = rd.split('-');
    var when  = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    if(isNaN(when.getTime())) return;
    var today = new Date(); today.setHours(0,0,0,0);

    var text = (today < when)
      ? 'Your membership renews on ' + when.getDate() + ' ' + MONTHS[when.getMonth()] +
        ' and covers this test.'
      : 'Your membership is active and covers this test.';

    var pill = document.querySelector('.paid-pill');
    if(!pill) return;
    var row  = pill.parentNode;
    var desc = row ? row.querySelector('.desc') : null;
    if(!desc || !desc.parentNode) return;

    var el = document.createElement('span');
    el.id = 'pv6-renews';
    el.className = 'pv6-renews';
    el.textContent = text;
    desc.parentNode.insertBefore(el, desc.nextSibling);
  }

  /* chips are presets on the page's own matcher, applied after flow v6 has
     booted and re-rendered the catalogue. The explainer card only appears
     when a GOAL was preset, i.e. when the preset came from the member's own
     lab results. Age and sex alone do not earn the claim. */
  function presetChips(){
    var age = clean(qp('age')),
        sex = clean(qp('sex')).toLowerCase(),
        goal= clean(qp('goal')).toLowerCase(),
        goalPicked = false;
    function pick(type,val){
      var wrap = document.querySelector('.mb-opts[data-mbtype="'+type+'"]');
      if(!wrap) return false;
      var btn = wrap.querySelector('.mb-chip[data-val="'+val+'"]');
      if(btn && !btn.classList.contains('on') && typeof window.mbPick === 'function'){
        try{ window.mbPick(btn,type); return true; }catch(e){}
      }
      return false;
    }
    if(['u35','35-49','50+'].indexOf(age) > -1) pick('age',age);
    if(['male','female'].indexOf(sex) > -1)     pick('sex',sex);
    if(goal){
      goal.split(',').slice(0,3).forEach(function(g){
        g = g.trim();
        if(/^[a-z]+$/.test(g) && pick('goal',g)) goalPicked = true;
      });
    }
    /* Gate on the parameter, not on whether we flipped the chip. The page
       restores saved matcher prefs, so a chip can already be on, pick()
       returns false, and the card silently never rendered. That is why it
       was missing on the live page. */
    if((goalPicked || goal) && !document.getElementById('pv6-preset')){
      var bar = document.getElementById('matchbar');
      if(bar && bar.parentNode){
        var card = document.createElement('div');
        card.id = 'pv6-preset';
        card.style.cssText = 'display:flex;gap:11px;align-items:flex-start;'+
          'background:rgba(44,89,69,.055);border:1px solid rgba(44,89,69,.16);'+
          'border-radius:14px;padding:13px 15px;margin:16px 0 0;';
        card.innerHTML =
          '<span style="flex:0 0 auto;width:19px;height:19px;border-radius:50%;'+
            'background:'+GREEN+';color:#fff;font-size:11px;line-height:19px;'+
            'text-align:center;margin-top:1px;">&#10003;</span>'+
          '<span style="font-size:13px;line-height:1.55;color:var(--taupe,#5d564e)">'+
            '<b style="display:block;font-weight:500;color:'+GREEN+';margin-bottom:2px;">'+
              'We picked these for you</b>'+
            'We reviewed your last blood work and pre-selected the add-ons most relevant '+
            'to you. They are highlighted below. Everything else is still there to browse.'+
          '</span>';
        bar.parentNode.insertBefore(card,bar);
      }
    }
  }

  /* ------------------------------------------------------------------
     Repeat add-ons: highlight what they bought last year.

     The catalogue's own matcher only knows this year's flagged markers, so
     a product someone bought in year one is invisible to it. Amit bought a
     cancer screen last year, his flagged marker is cholesterol, so the
     matcher had no reason to surface it and the repeat card told him to
     continue tracking something he then had to hunt for in a 35 item list.

     This adds a second highlight state, gold, distinct from the green
     "For you" ring so the two read as different reasons rather than two
     strengths of the same one. Repeat items are moved INTO the existing
     Recommended for you band but placed AFTER the matched ones: this
     year's markers lead, and the matched band already sorts in-house
     tests above supplier-fulfilled scans via mbInHouse().

     Re-applied on every catalogue render, because picking a chip
     re-renders the whole list and wipes anything we added.
     ------------------------------------------------------------------ */
  var RP_PRODUCTS = {
    spotmas:  'SPOT-MAS Cancer Test',
    dexa:     'DEXA Scan',
    insulin:  'Fasting Insulin + HOMA-IR',
    cortisol: 'Cortisol (Morning Serum)',
    gut:      'Gut Health Test'
  };

  function repeatNames(){
    var raw = clean(qp('rp')).toLowerCase();
    if(!raw) return [];
    return raw.split(',').map(function(s){ return RP_PRODUCTS[s.trim()]; })
              .filter(function(n){ return !!n; });
  }

  function injectRepeatCss(){
    if(document.getElementById('pv6-repeat-css')) return;
    var s = document.createElement('style');
    s.id = 'pv6-repeat-css';
    s.textContent =
      '.acard.pv6-repeat{box-shadow:0 0 0 2px ' + GOLD + ' !important;}' +
      '.acard.pv6-repeat .matchpill{display:none !important;}' +
      '.acard.pv6-repeat .pv6-againpill{display:inline-block;font-size:10.5px;' +
        'font-weight:600;color:#1D1D1D;background:' + GOLD + ';border-radius:20px;' +
        'padding:2px 9px;margin-left:8px;vertical-align:middle;white-space:nowrap;}' +
      '.acard.pv6-pulse{animation:pv6-pulse 1.1s ease-out 2;}' +
      '@keyframes pv6-pulse{0%,100%{box-shadow:0 0 0 2px ' + GOLD + ';}' +
        '50%{box-shadow:0 0 0 6px rgba(255,209,102,.55);}}' +
      '.pv6-tabdot{position:relative;}' +
      '.pv6-tabdot::after{content:"";position:absolute;top:5px;right:5px;width:7px;height:7px;' +
        'border-radius:50%;background:' + GOLD + ';box-shadow:0 0 0 2px #F7F4F1;}';
    document.head.appendChild(s);
  }

  function markRepeats(){
    var names = repeatNames();
    if(!names.length) return;
    injectRepeatCss();

    var cards = document.querySelectorAll('.acard'), found = [];
    for(var i=0;i<cards.length;i++){
      var t = cards[i].querySelector('.title');
      if(!t) continue;
      var label = t.textContent.trim();
      if(names.indexOf(label) === -1) continue;
      var card = cards[i];
      if(!card.classList.contains('pv6-repeat')){
        card.classList.add('pv6-repeat');
        var head = card.querySelector('.head');
        if(head && !head.querySelector('.pv6-againpill')){
          var pill = document.createElement('span');
          pill.className = 'pv6-againpill';
          pill.textContent = 'You did this last year';
          var titleEl = head.querySelector('.title');
          if(titleEl && titleEl.nextSibling) head.insertBefore(pill, titleEl.nextSibling);
          else head.appendChild(pill);
        }
      }
      found.push(card);
    }
    if(!found.length) return;

    /* Move into the Recommended for you band, after the matched cards.
       If no band exists (nothing matched this year) build one so the
       repeat items still lead the page. */
    /* Pull the repeat cards into the Recommended band first, then sort the
       whole band together so both rules apply across matched and repeat. */
    var band = document.querySelector('.recband-head');
    var target = band ? band.parentNode : null;
    if(!target){
      var firstGroup = document.querySelector('.addons');
      if(!firstGroup || !firstGroup.parentNode) return;
      target = document.createElement('div');
      target.className = 'addons';
      var h = document.createElement('div');
      h.className = 'recband-head';
      h.innerHTML = '<span class="rb-spark">&#8635;</span> Continue tracking';
      target.appendChild(h);
      firstGroup.parentNode.insertBefore(target, firstGroup);
    }
    /* Two rules compose here rather than compete.

       IN-HOUSE FIRST is the primary key: the page's own mbInHouse() already
       ranks our own blood, swab and stool tests above supplier-fulfilled
       scans, because Imaging carries booking friction we do not control and
       thinner margin.

       DID THIS LAST YEAR is the secondary key: inside each of those two
       groups, something the member already chose once leads, because it is
       the highest intent item on the page.

       Resulting order: in-house repeat, in-house matched, scan repeat,
       scan matched. On a tab where everything is a scan the first two tiers
       are empty, so a gold scan still leads that tab. The rule only ever
       demotes a gold item when one of our own tests shares the tab, which
       is exactly when it should be demoted. */
    var head = target.querySelector('.recband-head');
    var cards = [];
    var kids = target.children;
    for(var k=0;k<kids.length;k++){
      if(kids[k].classList && kids[k].classList.contains('acard')) cards.push(kids[k]);
    }
    function isScan(card){
      var m = card.querySelector('.modality');
      return !!m && /scan/i.test(m.textContent || '');
    }
    function rank(card){
      var scan = isScan(card) ? 2 : 0;
      var gold = card.classList.contains('pv6-repeat') ? 0 : 1;
      return scan + gold;
    }
    cards.sort(function(a,b){ return rank(a) - rank(b); });
    /* appendChild moves an existing child rather than copying it, so
       re-appending every card in sorted order leaves the band header in
       place and the cards ordered behind it. Deliberately not using an
       anchor node: the anchor would itself be one of the cards being
       moved, which corrupts the order. */
    cards.forEach(function(card){ target.appendChild(card); });
  }

  /* Which catalogue tabs hold a repeat product. Read from the page's own
     CATALOGUE global rather than a hardcoded map, so it stays correct if a
     product is ever moved between categories. */
  function repeatCats(){
    var names = repeatNames(), cats = [];
    if(!names.length || typeof CATALOGUE === 'undefined' || !CATALOGUE) return cats;
    try{
      Object.keys(CATALOGUE).forEach(function(cat){
        (CATALOGUE[cat].groups || []).forEach(function(g){
          (g.items || []).forEach(function(it){
            if(names.indexOf(it.name) > -1 && cats.indexOf(cat) === -1) cats.push(cat);
          });
        });
      });
    }catch(e){}
    return cats;
  }

  function tabButtons(){
    var host = document.getElementById('tabs');
    if(!host) return [];
    var kids = host.querySelectorAll('*');
    var out = [];
    for(var i=0;i<kids.length;i++){
      if(kids[i].children.length === 0 || kids[i].getAttribute('onclick')) out.push(kids[i]);
    }
    return out.length ? out : Array.prototype.slice.call(host.children);
  }

  /* Marks the tabs that hold a repeat product with a gold dot, so the
     member can see there is something for them on a tab they are not
     currently looking at. */
  function markRepeatTabs(){
    var cats = repeatCats();
    if(!cats.length || typeof CATALOGUE === 'undefined') return;
    var labels = cats.map(function(c){ return (CATALOGUE[c] && CATALOGUE[c].label) || ''; })
                     .filter(function(l){ return !!l; });
    if(!labels.length) return;
    tabButtons().forEach(function(el){
      var txt = (el.textContent || '').trim();
      for(var i=0;i<labels.length;i++){
        if(txt.indexOf(labels[i]) === 0 || txt === labels[i]){
          el.classList.add('pv6-tabdot');
          return;
        }
      }
    });
  }

  /* Open the tab holding a repeat product, once, on load. The page has its
     own auto-jump that ranks tabs by in-house matches; a product the member
     already bought outranks that, so we override it a beat later. */
  var jumped = false;
  function jumpToRepeatTab(){
    if(jumped) return;
    var cats = repeatCats();
    if(!cats.length || typeof CATALOGUE === 'undefined') return;
    var label = (CATALOGUE[cats[0]] && CATALOGUE[cats[0]].label) || '';
    if(!label) return;
    var btns = tabButtons();
    for(var i=0;i<btns.length;i++){
      var txt = (btns[i].textContent || '').trim();
      if(txt.indexOf(label) === 0 || txt === label){
        jumped = true;
        try{ btns[i].click(); }catch(e){}
        return;
      }
    }
  }

  /* The catalogue re-renders on every chip change, wiping our classes.
     Observe it and re-apply rather than hooking a named render function
     that may be renamed in a future build. */
  function watchCatalogue(){
    if(!repeatNames().length) return;
    var host = document.querySelector('.addons');
    host = host && host.parentNode;
    if(!host || !window.MutationObserver) return;
    var pending = false;
    var mo = new MutationObserver(function(){
      if(pending) return;
      pending = true;
      setTimeout(function(){
        pending = false;
        try{ markRepeats(); }catch(e){}
        try{ markRepeatTabs(); }catch(e){}
      }, 60);
    });
    mo.observe(host, {childList:true, subtree:true});
  }

  function wrapBooking(){
    if(typeof window.goBook !== 'function' || window.goBook.pvr) return;
    var orig = window.goBook;
    var patched = function(){
      try{
        var base = (typeof window.BOOKING_URL === 'string') ? window.BOOKING_URL : '';
        if(!base) return orig.apply(this,arguments);
        var fn = qp('fn'), em = EMAIL, q = [];
        if(fn) q.push('name='  + encodeURIComponent(fn));
        if(em) q.push('email=' + encodeURIComponent(em));
        q.push('utm_source=whatsapp');
        q.push('utm_medium=crm');
        q.push('utm_campaign=' + encodeURIComponent(qp('utm_campaign') || 'renewal_sep26'));
        if(typeof window.chtPush === 'function'){
          try{ window.chtPush('addon_booking_click',{
            addons_in_cart: Object.keys(window.cart||{}).length,
            personalised: !!fn
          }); }catch(e){}
        }
        window.location.href = base + (base.indexOf('?') > -1 ? '&' : '?') + q.join('&');
      }catch(e){ return orig.apply(this,arguments); }
    };
    patched.pvr = true;
    window.goBook = patched;
  }

  var personalised = firstName() || qp('mk') !== null || qp('rp') !== null;

  /* 1. mask now, synchronously, before first paint */
  if(personalised){
    try{ mask(true); }catch(e){}
    /* watchdog: never leave content hidden */
    setTimeout(function(){ if(masked) try{ mask(false); }catch(e){} }, 1500);
  }

  /* 2. write after the page's own applyCtxCopy, 3. reveal */
  function onReady(){
    try{ writeCopy(); }catch(e){}
    try{ mask(false); }catch(e){}
    setTimeout(function(){
      try{ renewalLine(); }catch(e){}
      try{ repeatCard(); }catch(e){}
      try{ presetChips(); }catch(e){}
      try{ jumpToRepeatTab(); }catch(e){}
      try{ markRepeats(); }catch(e){}
      try{ markRepeatTabs(); }catch(e){}
      try{ watchCatalogue(); }catch(e){}
      try{ wrapBooking(); }catch(e){}
      try{ scrubUrl(); }catch(e){}
    }, 900);
  }

  if(!personalised){
    document.addEventListener('DOMContentLoaded', function(){
      setTimeout(function(){
        try{ wrapBooking(); }catch(e){}
        try{ scrubUrl(); }catch(e){}
      }, 900);
    });
  } else if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
